import { useLocation, useNavigate } from 'react-router'
import { webhooksApi } from '~/apis/webhooksApi'
import { useUserState } from '~/atoms/UserState'
import { ApplicationRoutes } from '~/types/RoutingTypes'

import { WebhooksListPage } from '@mangovoice/webhooks-ui'

export const WebhooksPage = () => {
  const { pbxId } = useUserState()
  const navigate = useNavigate()
  const { search } = useLocation()

  return (
    <WebhooksListPage
      api={webhooksApi}
      pbxId={pbxId ?? 0}
      navigate={navigate}
      webhookDetailRoute={(id: number) =>
        `${ApplicationRoutes.INTEGRATIONS}/${id}${search}`
      }
      imageBaseUrl="/integrations/"
    />
  )
}
